

class User {

    public static tup : any

}

export default User
